/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_Payment_Status_UnpaidInputs */

const vi_expense_payment_status_unpaid = /** @type {(inputs: Expense_Payment_Status_UnpaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa thanh toán`)
};

/**

* @param {Expense_Payment_Status_UnpaidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_payment_status_unpaid = /** @type {((inputs?: Expense_Payment_Status_UnpaidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_Payment_Status_UnpaidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_payment_status_unpaid(inputs)
});